import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"


export default function AppWebSupplierGroupsAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
        filterSelectedOptions={false}
        multiple
        label="Web Supplier Groups"
        placeholder="Your groups of web suppliers"
        urlAjax={`${BACKEND_APIS.CRUD}/user/web_supplier_group?selectorFormat=true`}
        {...props}
    />
}